export default "__VITE_ASSET__DiMN_zG2__"